<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用"|"作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '添加企业')" class="search-btn">添加企业</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>

            <!-- 审核状态筛选 -->
            <div style="margin-top: 10px; display: flex; align-items: center;">
              <span style="margin-right: 10px;">审核状态：</span>
              <RadioGroup v-model="filterStatus" @on-change="handleFilterChange">
                <Radio label="">全部</Radio>
                <Radio label="0">已审核</Radio>
                <Radio label="1">待审核</Radio>
              </RadioGroup>

              <!-- 统计信息 -->
              <div class="statistics" style="margin-left: 20px;">
                <Tag color="red">总计：{{statistics.total}}</Tag>
                 <Tag color="orange" style="margin-left: 10px;">已审核：{{statistics.approved}}</Tag>
                <Tag color="blue" style="margin-left: 10px;">待审核：{{statistics.pending}}</Tag>

<!--                <Badge :count="statistics.total" :text="'总计:'+statistics.total" type="default"></Badge>-->
<!--                <Badge :count="statistics.approved" text="已审核" type="success" style="margin-left: 10px;"></Badge>-->
<!--                <Badge :count="statistics.pending" text="待审核" type="warning" style="margin-left: 10px;"></Badge>-->
              </div>
            </div>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border
                 :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">

              <FormItem
                label="用户名"
                prop="username"
                v-if="formValidate.Id == 0"
              >
                <Input
                  v-model="formValidate.username"
                  placeholder="请输入用户名"
                ></Input>

              </FormItem>
              <FormItem
                label="单位名称"
                prop="Cname"
              >
                <Input
                  v-model="formValidate.Cname"
                  placeholder="请输入单位名称"
                ></Input>
              </FormItem>
              <FormItem
                label="单位地址"
                prop="Caddress"
              >
                <Input
                  v-model="formValidate.Caddress"
                  placeholder="请输入单位地址"
                ></Input>
              </FormItem>
              <FormItem
                label="单位简介"
                prop="Cintroduce"
              >
                <Input
                  type="textarea"
                  v-model="formValidate.Cintroduce"
                  placeholder="请输入单位简介"
                ></Input>
              </FormItem>
              <FormItem label="法人代表" prop="Crepresentative">
                <Input
                  v-model="formValidate.Crepresentative"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="联系人" prop="Ccontacts">
                <Input
                  v-model="formValidate.Ccontacts"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="联系电话" prop="Cphone">
                <Input
                  v-model="formValidate.Cphone"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="统一社会信用代码" prop="Ccode">
                <Input
                  v-model="formValidate.Ccode"
                  placeholder="请输入"
                ></Input>
              </FormItem>
              <FormItem label="营业执照" prop="companyimg">
                 <Button size="small" @click="viewLicenseFromTable(formValidate)">查看营业执照</Button>
<!--                <div v-if="formValidate.companyimg">-->
<!--                  <img :src="'data:image/jpeg;base64,' + formValidate.companyimg" style="max-width: 200px; max-height: 200px; border: 1px solid #ddd;" alt="营业执照">-->
<!--                  <div style="margin-top: 5px;">-->
<!--                   -->
<!--                 -->
<!--                  </div>-->
<!--                </div>-->

              </FormItem>
              <FormItem label="规模" prop="Cscale">
                <el-select
                  v-model="formValidate.Cscale"
                  filterable
                  default-first-option
                  placeholder="请选择规模">
                  <el-option
                    v-for="item in CscaleList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="行业" prop="Cindustry">
                <el-select
                  v-model="formValidate.Cindustry"
                  filterable

                  default-first-option
                  placeholder="请选择行业，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in CindustryList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>

              </FormItem>
              <FormItem label="类型" prop="Ctype">
                <el-select
                  v-model="formValidate.Ctype"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择，如果没有合适的类型可以自己创建">
                  <el-option
                    v-for="item in CtypeList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>

            </Form>
          </Modal>

          <!-- 营业执照查看模态框 -->
          <Modal v-model="licenseModal.show" :title="licenseModal.title" :footer-hide="true" :width="800">
            <div style="text-align: center;">
              <viewer :options="{ zIndex: 9999, toolbar: { zoomIn: 1, zoomOut: 1, oneToOne: 1, reset: 1, rotateLeft: 1, rotateRight: 1 } }">
                <img :src="licenseModal.imageUrl" style="max-width: 100%; max-height: 600px; cursor: zoom-in;">
              </viewer>
            </div>
          </Modal>
        </Card>
      </i-col>
    </Row>

  </div>
</template>

<script>

import {
  getCompanylist,
  operationCompany,
  getLicenseImage
} from '@/api/scinfo/scinfo.js'
import {
  patchuser
} from '@/api/user'
import { getsysparameterList } from '@/api/system/sys_parameter'

let moment = require('moment')
export default {

  data () {
    return {
      spinShow: false,
      fullscreenLoading: false,
      CindustryList: [],
      CscaleList: [],
      CtypeList: [],
      formValidate: {},
      searchVal: '',
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: '新建'
      },
      licenseModal: {
        show: false,
        title: '营业执照',
        imageUrl: ''
      },
      tableSelectIdList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数
      filterStatus: '', // 审核状态筛选
      statistics: {
        total: 0,
        approved: 0,
        pending: 0
      },

      ruleValidate: {
        // admin_user: [{ required: true, message: "请选择管理用户", trigger: "change"}],
        Cname: [
          {
            required: true,
            message: '单位名字不能为空',
            trigger: 'blur'
          }
        ],
        username: [
          {
            required: true,
            message: '用户名不能为空',
            trigger: 'blur'
          }
        ],
        Ctype: [
          {
            required: true,
            message: '请选择',
            trigger: 'change'
          }
        ],
        Cindustry: [
          {
            required: true,
            message: '请选择',
            trigger: 'change'
          }
        ]

      },
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '用户名',
          key: 'username',
          width: 120,
          align: 'center',
          tooltip: 'true',
          fixed: 'left',
          sortable: true
        },
        {
          title: '单位名称',
          key: 'Cname',
          tooltip: 'true',
          align: 'center',
          width: 200,
          fixed: 'left',
          sortable: true
        },
        {
          title: '单位简介',
          key: 'Cintroduce',
          tooltip: 'true',
          align: 'center',
          width: 200,
          sortable: true
        },
        {
          title: '单位地址',
          key: 'Caddress',
          tooltip: 'true',
          align: 'center',
          width: 200,
          sortable: true
        },
        {
          title: '统一社会代码',
          key: 'Ccode',
          width: 200,
          tooltip: 'true',
          align: 'center',
          sortable: true
        },
        {
          title: '联系人',
          key: 'Ccontacts',
          tooltip: 'true',
          align: 'center',
          width: 120,
          sortable: true
        },
        {
          title: '联系电话',
          key: 'Cphone',
          width: 150,
          tooltip: 'true',
          align: 'center',
          sortable: true
        },
        {
          title: '营业执照',
          key: 'companyimg',
          width: 120,
          align: 'center',
          render: (h, params) => {
              return h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.viewLicenseFromTable(params.row)
                  }
                }
              }, '查看执照')
          }
        },
        {
          title: '审核状态',
          key: 'cstate',
          width: 150,
          fixed: 'right',
          align: 'center',
          render: (h, params, vm) => {
            return h('div', [
              h('i-switch', {
                props: {
                  value: params.row.Cstate === 0 // 0为已审核，1为待审核
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  'on-change': () => {
                    this.onSwitchState(params)
                  }
                }
              }),
              h('span', {
                style: {
                  fontSize: '12px',
                  color: params.row.Cstate === 0 ? '#19be6b' : '#ff9900'
                }
              }, params.row.Cstate === 0 ? '已通过' : '待审核')
            ])
          }
        },
        {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editModal(params.row, 'put', '修改')
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.delData(params)
                    }
                  }
                },
                '删除'
              )
            ])
          }

        }
      ]
    }
  },
  methods: {
    // 处理筛选变更
    handleFilterChange () {
      this.pageNum = 1
      this.getCompanylist()
    },

    // 查看营业执照
    async viewLicense () {
      if (!this.formValidate.Id) return
      this.fullscreenLoading = true
      try {
        this.licenseModal.imageUrl = 'data:image/jpeg;base64,' + this.formValidate.companyimg
        this.licenseModal.show = true
      } finally {
        this.fullscreenLoading = false
      }
    },

    // 从表格查看营业执照 - 异步获取图片
    async viewLicenseFromTable (row) {
      this.fullscreenLoading = true
      try {
        // 如果已经有缓存的图片数据，直接显示
        if (row.companyimg) {
          this.licenseModal.imageUrl = 'data:image/jpeg;base64,' + row.companyimg
          this.licenseModal.show = true
          return
        }

        // 否则异步获取图片
        const res = await getLicenseImage(row.Id)
        console.log(res)
        if (res.data) {
          if (res.data.code === 0) {
            this.licenseModal.imageUrl = 'data:image/jpeg;base64,' + res.data.license
          this.licenseModal.show = true
          } else {
            this.$Message.error(res.data.msg)
          }
          // console.log( res)
          // 创建 blob URL
          // const blob = new Blob([res.license], { type: 'image/jpeg' })
          // this.licenseModal.imageUrl = URL.createObjectURL(blob)
        } else {
          this.$Message.error('获取营业执照失败')
        }
      } catch (error) {
        this.$Message.error('获取营业执照失败: ' + error.message)
      } finally {
        this.fullscreenLoading = false
      }
    },

    // 移除营业执照
    removeLicense () {
      this.formValidate.companyimg = ''
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
    },

    // 审核状态切换 (0为已审核，1为待审核)
    onSwitchState (editData) {
      const newState = editData.row.Cstate === 1 ? 0 : 1

      const EditData = {
        Id: editData.row.Id,
        Cstate: newState
      }
      operationCompany(EditData, 'put').then(res => {
        if (res.data.code === 0) {
          editData.row.Cstate = newState
          this.$Message.success(`${res.data.msg}`)
          // 更新统计信息
          this.updateStatistics()
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },

    // 更新统计信息
    updateStatistics () {
      // 计算已审核和待审核的数量
      let approved = 0
      let pending = 0

      this.tableData.forEach(item => {
        if (item.Cstate === 0) {
          approved++
        } else {
          pending++
        }
      })

      this.statistics = {
        total: this.pageTotal,
        approved: approved,
        pending: pending
      }
    },

    getCompanylist (key, value) {
      this.spinShow = true
      // 添加状态筛选
      const params = {
        page: this.pageNum,
        limit: this.pageSize,
        key: key || this.searchVal,
        value: value
      }

      // 如果有筛选状态，添加到请求参数
      if (this.filterStatus !== '') {
        params.status = this.filterStatus
      }

      getCompanylist(this.pageNum, this.pageSize, key, value, this.filterStatus).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          this.tableData = res.data.data
  this.statistics = {
        total: res.data.total,
        approved: res.data.approved,
        pending: res.data.pending
      }
          // 更新统计信息
          // this.updateStatistics()
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },

    getCscaleList () {
      getsysparameterList('company_info', 'Cscale').then(res => {
        if (res.data.code === 0) {
          this.CscaleList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },

    // table 选中的ID
    handleSelectChange (val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.Id)
      })

      this.tableSelectIdList = SelectIdList
    },

    closeModal () {
      this.dialog.show = false
    },
    getCindustryList () {
      getsysparameterList('company_info', 'Cindustry').then(res => {
        if (res.data.code === 0) {
          this.CindustryList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    getCtypeList () {
      getsysparameterList('company_info', 'Ctype').then(res => {
        if (res.data.code === 0) {
          this.CtypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },

    editModal (paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true
      this.modalMap.modalTitle = mtitle
      this.editModalData = meth
      this.getCindustryList()
      this.getCtypeList()
      this.getCscaleList()
      if (paramsRow && paramsRow.Id) {
        this.formValidate = {
          Id: paramsRow.Id,
          Cname: paramsRow.Cname,
          Sbid: paramsRow.Sbid,
          Caddress: paramsRow.Caddress,
          Cintroduce: paramsRow.Cintroduce,
          Crepresentative: paramsRow.Crepresentative,
          Ccontacts: paramsRow.Ccontacts,
          Cphone: paramsRow.Cphone,
          Ccode: paramsRow.Ccode,
          Clicense: paramsRow.Clicense,
          Cindustry: paramsRow.Cindustry,
          Ctype: paramsRow.Ctype,
          Cstate: paramsRow.Cstate,
          cstate: paramsRow.cstate || 0,
          Cuid: paramsRow.Cuid,
          username: paramsRow.username,
          Cscale: paramsRow.Cscale,
          companyimg: paramsRow.companyimg || ''
        }
      } else {
        this.formValidate = {
          Id: 0,
          Cname: '',
          Sbid: '',
          Caddress: '',
          Cintroduce: '',
          Crepresentative: '',
          Ccontacts: '',
          Cphone: '',
          Ccode: '',
          Clicense: '',
          Cindustry: '',
          Ctype: '',
          Cstate: 0,
          cstate: 0,
          Cuid: 0,
          username: '',
          companyimg: ''
        }
      }
    },
    handleSubmit (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            operationCompany(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)

                if (this.searchVal) {
                  this.getCompanylist(this.searchVal)
                } else {
                  this.getCompanylist()
                }
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
          // this.$Message.success('Success!');
        } else {
          this.$Message.error('缺少必要参数')
        }
      })
    },

    handleReset (name) {
      this.$refs[name].resetFields()
    },

    handlerDelete () {
      // console.log(this.tableSelectIdList.length)
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中企业嘛？ `)) {
          operationCompany({ 'id_list': this.tableSelectIdList }, 'delete').then(
            res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getCompanylist(this.searchVal)
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    // 删除
    delData (params) {
      if (confirm(`确定要删除 ${params.row.Cname}`)) {
        // console.log(params.row.id)
        operationCompany(
          {
            'Id': params.row.Id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.index, 1)
            // 更新统计信息
            this.updateStatistics()
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },

    // 点击节点
    // 翻页
    changePage (value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getCompanylist(this.searchVal)
      } else {
        this.getCompanylist()
      }
    },
    // 切换分页
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getCompanylist(this.searchVal)
      } else {
        this.getCompanylist()
      }
    },
    searchinput () {
      if (this.searchVal) {
        this.getCompanylist(this.searchVal)
      } else {
        this.getCompanylist()
      }
    }
  },

  watch: {
    searchVal (val) {
      this.searchVal = val
      // this.getServerList(this.searchVal)
    }
  },
  mounted () {
    this.getCompanylist()
  }
}

</script>

<style lang="less" scoped>
.search-con {
  padding: 10px 0;

  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }

    &-input {
      display: inline-block;
      width: 200px;
      margin-left: 2px;
    }

    &-btn {
      margin-left: 2px;
    }
  }
}

.statistics {
  display: flex;
  align-items: center;

  .ivu-badge {
    margin-right: 10px;
  }
}
</style>
